module.exports = __webpack_public_path__ + "static/media/dont-stop.2dc541fe.gif";